import Decimal from 'decimal.js';
import { isOriginInspectionDocument, isTransportDocument, type DocumentType } from '../document/document-types';
import { calculateAmounts, type MoneySummary } from './amounts';
import { calculateCustomsValues } from './settlement-calculations';
import type { TradeInput } from './schema';

export function calculateDocumentAmounts(input: TradeInput, type: DocumentType): MoneySummary {
  if (isOriginInspectionDocument(type)) return { lines: input.items.map(() => null), subtotal: null, total: null };
  if (type === 'INSURANCE_POLICY') return { lines: input.items.map(() => null), subtotal: null, total: input.insuredAmount ? new Decimal(input.insuredAmount).toFixed(2) : null };
  if (isTransportDocument(type) && type !== 'SHIPPING_ADVICE') {
    return { lines: input.items.map(() => null), subtotal: null, total: null };
  }
  if (type === 'SHIPPING_ADVICE') {
    return calculateAmounts({ ...input, freight: '0', insurance: '0', otherCharges: '0', discount: '0' });
  }
  const amounts = calculateAmounts(input, {
    missingAdjustmentsAsZero: type === 'PURCHASE_ORDER' || type === 'SALES_CONTRACT',
    missingItemPricesAsZero: type === 'SALES_CONTRACT',
  });
  if (type === 'CUSTOMS_INVOICE') {
    return { ...amounts, total: calculateCustomsValues({ subtotal: amounts.subtotal, incoterm: input.incoterm, freight: input.freight, insurance: input.insurance }).cif };
  }
  return amounts;
}
